import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableService } from '../../../../_services/table.service';
import { HighlightDirective } from '../../../../_directives/highlight.directive';
import { GalleriaModule } from 'primeng/galleria';

@Component({
  selector: 'app-detail-view',
  standalone: true,
  imports: [CommonModule, HighlightDirective, GalleriaModule],
  templateUrl: './detail-view.component.html',
  styleUrl: './detail-view.component.scss',
})
export class DetailViewComponent {
  detail_view_product: any = {};
  cols: any[] = [];
  detailViewTemplate: any;
  secondaryTableDetails: any[] = [];
  searchedWords: string[] = [];
  imageBaseUrls: any = {};
  columnsFetched = false;
  showMoreButton = false;
  showMoreButtonIndex = -1;
  showMore = false;
  showCollapse = false;

  constructor(private tableService: TableService) {}

  ngOnInit(): void {
    this.tableService.getDetailViewProduct().subscribe((data) => {
      this.detail_view_product = data || {};
      this.columnsFetched ? this.getCols() : '';
    });
    
    this.tableService.getDetailViewTemplate().subscribe((data) => {
      this.detailViewTemplate = data;
    });
    
    this.tableService.getSecondaryTableDetails().subscribe((data) => {
      this.secondaryTableDetails = data;
      this.getCols();
      this.columnsFetched = true;
    });
    
    this.tableService.getImagesBaseUrl().subscribe((data) => {
      this.imageBaseUrls = data;
    });
    
    this.tableService.getSearchedWords().subscribe((data) => {
      this.searchedWords = data;
    });
  }

  getCols() {
    this.tableService.getCols().subscribe((data) => {
      this.cols = data.map((obj) => ({ ...obj }));
    });

    this.checkShowMoreButton();
  }

  hasSecondaryData(): boolean {
    return this.detail_view_product.gbrn_products && 
           this.detail_view_product.gbrn_products.length > 0;
  }

  getSecondaryData(): any[] {
    return this.detail_view_product.gbrn_products || [];
  }

  getFieldValues(field: string): any[] {
    const values: any[] = [];

    // Add primary product value if it exists
    if (
      this.detail_view_product &&
      this.detail_view_product[field] !== undefined &&
      this.detail_view_product[field] !== null &&
      this.detail_view_product[field] !== ''
    ) {
      values.push(this.detail_view_product[field]);
    }

    // Add secondary products' values
    if (this.detail_view_product && this.detail_view_product.gbrn_products) {
      this.detail_view_product.gbrn_products.forEach((item: any) => {
        if (
          item[field] !== undefined &&
          item[field] !== null &&
          item[field] !== ''
        ) {
          values.push(item[field]);
        }
      });
    }

    // Remove duplicates
    return [...new Set(values)];
  }

  hasFieldData(field: string): boolean {
    return this.getFieldValues(field).length > 0;
  }

  checkSecondaryTableData(): boolean {
    return this.hasSecondaryData();
  }

  hasImageFields(): boolean {
    return this.cols.some(
      (col) => col.fieldDataType === 'image' && this.hasFieldData(col.field)
    );
  }

  getImageCols(): any[] {
    return this.cols.filter(
      (col) => col.fieldDataType === 'image' && this.hasFieldData(col.field)
    );
  }

  checkShowMoreButton() {
    this.showMoreButtonIndex = -1;
    this.showMoreButton = false;
    this.showMore = false;

    let loopBreakIndex = -1;

    for (let i = 0; i < this.cols.length; i++) {
      const col = this.cols[i];

      if (col.detail_view_order && col.fieldDataType !== 'image') {
        if (this.hasFieldData(col.field)) {
          loopBreakIndex++;
        }
      }

      if (loopBreakIndex === 10) {
        this.showMoreButtonIndex = i;
        this.showMoreButton = true;
        break;
      }
    }
  }

  addDataSpace(data: any) {
    if (!data) return data;
    let result = data.toString();
    result = result.replace(/\n|\r\n/gm, '<br/>');
    result = result.replace(/;/gi, '; ');
    return result;
  }

  getClassWidth(template_col: any) {
    return this.detailViewTemplate
      ? `card-col-${template_col}1`
      : `card-col-${template_col}`;
  }

  valueIsArray(rowData: any) {
    return Array.isArray(rowData);
  }

  // Gallery
  displayBasic: boolean = false;
  images: any[] | undefined;

  responsiveOptions: any[] = [
    {
      breakpoint: '1500px',
      numVisible: 5,
    },
    {
      breakpoint: '1024px',
      numVisible: 3,
    },
    {
      breakpoint: '768px',
      numVisible: 2,
    },
    {
      breakpoint: '560px',
      numVisible: 1,
    },
  ];

  getImageUrl(col: any, fileName: string): string {
    if (!fileName) return '';
    const header = col.header ? col.header.toLowerCase() : '';
    if (header.includes('company logo')) {
      return 'https://chemrobotics.com/agropat/images/innovators_logo/' + fileName;
    }
    if (header.includes('category image')) {
      return 'https://chemrobotics.com/agropat/images/agro_pro_dir/product_image1/' + fileName;
    }
    if (col.field === 'chemicalStructure') {
      return 'https://chemrobotics.com/agropat/images/chemical_structure/' + fileName;
    }
    const baseUrl = this.imageBaseUrls[col.field] ? this.imageBaseUrls[col.field] : '';
    return 'https://chemrobotics.com/agropat/images/' + baseUrl + fileName;
  }

  ImageFullView(col: any, item: any) {
    this.images = [
      {
        itemImageSrc: this.getImageUrl(col, item),
        alt: 'CHEMICAL STRUCTURE',
        title: 'Title 4',
      },
    ];

    this.displayBasic = true;
  }

  onCloseGalleria(): void {
    this.displayBasic = false;
  }
}